import { render, staticRenderFns } from "./DeliveryOrderRelation.vue?vue&type=template&id=efc6e266&scoped=true"
import script from "./DeliveryOrderRelation.vue?vue&type=script&lang=js"
export * from "./DeliveryOrderRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc6e266",
  null
  
)

export default component.exports